import { render } from "./BonusLinear.vue?vue&type=template&id=cbd5f53c&scoped=true"
const script = {}

import "./BonusLinear.vue?vue&type=style&index=0&id=cbd5f53c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd5f53c"]])

export default __exports__